import loadable from '@loadable/component';

// 懒加载组件
const ItemMainBarcodeManagement = loadable(() => import('./itemMainBarcodeManagement/ItemMainBarcodeManagement'));
const StockUpInventoryQuery = loadable(() => import('./stockUpInventoryQuery/StockUpInventoryQuery'));
const BoxPreparation = loadable(() => import('./boxPreparation/BoxPreparation'));
const BoxDetailModify = loadable(() => import('./boxPreparation/boxDetailModify/BoxDetailModify'));
const ItemUsingDetailQuery = loadable(() => import('./itemUsingDetailQuery/ItemUsingDetailQuery'));
const StockupDeliveryQuery = loadable(() => import('./stockupDeliveryQuery/StockupDeliveryQuery'));
const StockupDeliveryModify = loadable(() => import('./stockupDeliveryQuery/stockupDeliveryModify/StockupDeliveryModify'));
const StockupDeliveryDetailQuery = loadable(() => import('./stockupDeliveryDetailQuery/StockupDeliveryDetailQuery'));
const ImplantableDeliveryManagement = loadable(() => import('./implantableDeliveryManagement/ImplantableDeliveryManagement'));
const OperationImplantationManagement = loadable(() => import('./operationImplantationManagement/OperationImplantationManagement'));
const OperationImplantationDetailModify = loadable(() => import('./operationImplantationManagement/operationImplantationDetailModify/OperationImplantationDetailModify.js'));
const ImplantableDeliveryDetailModify = loadable(() => import('./implantableDeliveryManagement/implantableDeliveryDetailModify/ImplantableDeliveryDetailModify'));
const StockupDeliveryQuery2308 = loadable(() => import('./stockupDeliveryQuery2308/StockupDeliveryQuery'));
const StockupDeliveryModify2308 = loadable(() => import('./stockupDeliveryQuery2308/stockupDeliveryModify/StockupDeliveryModify'));
const StockupDeliveryWithUpstreamQuery = loadable(() => import('./stockupDeliveryWithUpstreamQuery/StockupDeliveryQuery'));
const StockupDeliveryWithUpstreamModify = loadable(() => import('./stockupDeliveryWithUpstreamQuery/stockupDeliveryModify/StockupDeliveryModify'));
const ImplantableCycleDeliveryManagement = loadable(() => import('./implantableCycleDeliveryManagement/ImplantableCycleDeliveryManagement'));

export const subRoutes = [
  {
    // 251007耗材条码维护
    path: '/ItemMainBarcodeManagement',
    component: ItemMainBarcodeManagement
  },
  {
    // 254001备货库存查询
    path: '/StockUpInventoryQuery',
    component: StockUpInventoryQuery
  },
  {
    // 254004骨科包准备
    path: '/BoxPreparation',
    component: BoxPreparation
  },
  {
    // 254004骨科包准备 -- 骨科包明细编辑
    path: '/BoxDetailModify',
    component: BoxDetailModify
  },
  {
    // 258005耗材使用跟踪查询
    path: '/ItemUsingDetailQuery',
    component: ItemUsingDetailQuery
  },
  {
    // 254003备货发货单查询
    path: '/StockupDeliveryQuery',
    component: StockupDeliveryQuery
  },
  {
    // 254003备货发货单查询 -- 发货单明细编辑
    path: '/StockupDeliveryModify',
    component: StockupDeliveryModify
  },
  {
    // 254006备货发货单明细查询
    path: '/StockupDeliveryDetailQuery',
    component: StockupDeliveryDetailQuery
  },
  {
    // 253009 植入性发货单管理
    path: '/ImplantableDeliveryManagement',
    component: ImplantableDeliveryManagement
  },
  {
    // 251021 植入手术管理
    path: '/OperationImplantationManagement',
    component: OperationImplantationManagement
  },
  {
    // 251021 植入手术管理明细编辑
    path: '/OperationImplantationDetailModify',
    component: OperationImplantationDetailModify
  },
  {
    // 253009 植入性发货单管理明细编辑
    path: '/ImplantableDeliveryDetailModify',
    component: ImplantableDeliveryDetailModify
  },
  {
    // 254003 备货发货单查询
    path: '/StockupDeliveryQuery2308',
    component: StockupDeliveryQuery2308
  },
  {
    // 254003 备货发货单查询
    path: '/StockupDeliveryModify2308',
    component: StockupDeliveryModify2308
  },
  {
    // 292003 上游：高值发货单管理
    path: '/StockupDeliveryWithUpstreamQuery',
    component: StockupDeliveryWithUpstreamQuery
  },
  {
    // 292003 上游：高值发货单管理明细修改
    path: '/StockupDeliveryWithUpstreamModify',
    component: StockupDeliveryWithUpstreamModify
  },
  {
    // 253017 供应商：植入性循环发货
    path: '/ImplantableCycleDeliveryManagement',
    component: ImplantableCycleDeliveryManagement
  }
];
